exports.onClientEntry = () => {
	require('babel-polyfill');
}



// WEBPACK FOOTER //
// ./gatsby-browser.js